import { useEffect } from "react";
import {
  useChannelActionContext,
  useChannelStateContext,
} from "stream-chat-react";
import type { Channel } from "stream-chat";

const getFirstUnreadMessageId = async (
  channel: Channel
): Promise<string | undefined> => {
  const unreadCount = channel.countUnread();

  if (unreadCount === 0) return undefined;

  const response = await channel.query({
    messages: { offset: unreadCount - 1, limit: 1 },
  });

  return response.messages[0]?.id;
};

export const JumpToFirstUnreadMessage = () => {
  const { jumpToMessage } = useChannelActionContext();
  const { channel } = useChannelStateContext();

  useEffect(() => {
    const jumpToFirstUnreadMessage = async () => {
      const firstUnreadMessageId = await getFirstUnreadMessageId(channel);

      if (!firstUnreadMessageId) return;

      try {
        await jumpToMessage(firstUnreadMessageId);
      } catch (error) {}
    };

    void jumpToFirstUnreadMessage();
  }, [channel, jumpToMessage]);

  return <></>;
};
